import React from 'react';
import { BillingAccount } from '../../../../models/BillingAccount';
import './PastDue.scss';

interface AccountPastDueProps {
    billingAccount: BillingAccount;
}

function AccountPastDue({
    billingAccount
}: AccountPastDueProps) {
    if (billingAccount.stripeSubscriptionStatus !== 'past_due') return null;

    const gracePeriodEndsDate = billingAccount.stripeSubscriptionGracePeriodEnd ? new Date(billingAccount.stripeSubscriptionGracePeriodEnd) : null;
    const gracePeriodMessage = gracePeriodEndsDate ? `Periodo de gracia hasta el ${gracePeriodEndsDate.toLocaleDateString('es-MX', {day: '2-digit', month: 'long'})}, por favor actualice su método de pago.` : 'Por favor actualice su método de pago para evitar la suspensión de su cuenta.';

    return (
        <div className="pastDueSection">
            <div className='iconTitle'>
                <i className="material-icons">
                    warning
                </i>
                <p>
                    Pago Vencido
                </p>
            </div>
            <div className='textLink'>
                <p>
                    {gracePeriodMessage}
                </p>
                <a href={billingAccount.latestInvoicePaymentLink || '#'} target="_blank" rel="noopener noreferrer">
                    Actualizar método de pago
                </a>
            </div>
        </div>
    );
}

export default AccountPastDue;

